import accountReducer from './account'
import agentReducer from './agent'
import topUpReducer from './top-up'
import kolUpReducer from './kol'

const rootReducer = {
  account: accountReducer,
  agent: agentReducer,
  topUp: topUpReducer,
  kol: kolUpReducer,
}

export default rootReducer
